import UserOnCompanyRoleSelect from 'src/components/Selects/UserOnCompanyRoleSelect'

import { CompanyUserRole } from '../../../../types/graphql'
import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<CompanyUserRole, TKey>
  isDisabled?: boolean
  label?: React.ReactNode
}
const UserOnCompanyRoleSelectField = <TKey extends string>({
  caption,
  field,
  isDisabled,
  label,
}: Props<TKey>) => {
  return (
    <UserOnCompanyRoleSelect
      isDisabled={isDisabled}
      caption={caption}
      label={label}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default UserOnCompanyRoleSelectField
